/**
 * File containing so called "quarks", constants for design systems.
 */

export const BASE_MARGIN = 8

const margins = {
  /** 2px */
  xxsmall: `${(BASE_MARGIN * 1) / 4}px`,
  /** 4px */
  xsmall: `${(BASE_MARGIN * 1) / 2}px`,
  /** 8px */
  small: `${BASE_MARGIN * 1}px`,
  /** 16px */
  medium: `${BASE_MARGIN * 2}px`,
  /** 24px */
  large: `${BASE_MARGIN * 3}px`,
  /** 32px */
  xlarge: `${BASE_MARGIN * 4}px`,
  /** 40px */
  xxlarge: `${BASE_MARGIN * 5}px`,
  /** 64px */
  huge: `${BASE_MARGIN * 8}px`,
}

// If the key is a number, we'll grab the margin at index key,
// if it doesn't exist, the key is used as a multiplier to the base
const dynamicMargins = new Proxy(margins, {
  get(target, key) {
    //@ts-ignore
    const val = target[key]

    if (val !== undefined) return val

    const numberKey = Number(key)

    if (!Number.isNaN(numberKey)) {
      return `${BASE_MARGIN * numberKey}px`
    }

    return undefined
  },
}) as typeof margins & { [dynamic: number]: string }

const borderRadii = {
  /** 3px */
  small: '3px',
  /** 5px */
  medium: '5px',
  /** 8px */
  large: '8px',
  /** 100% */
  round: '100%',
}

const duration = {
  tooltipEnterDelay: 400,
}

const fontSizes = {
  /** 8px */
  xxsmall: '0.5rem',
  /** 10px */
  xsmall: '0.625rem',
  /** 12px - as Classes.TEXT_SMALL from '@blueprintjs/core' */
  small: '0.75rem',
  /** 14px - default text size */
  medium: '0.875rem',
  /** 16px - as Classes.TEXT_LARGE from '@blueprintjs/core' */
  large: '1rem',
  /** 18px */
  xlarge: '1.125rem',
  /** 20px */
  xxlarge: '1.25rem',
}

const fontWeights = {
  /** 100 */
  thin: 100,
  /** 400 - default weight */
  medium: 400,
  /** 700 */
  bold: 700,
}

export default {
  margins: dynamicMargins,
  borderRadii,
  duration,
  fontSizes,
  fontWeights,
}
